<template>
<div class="row">
  <div class="column col-md-4">
    <label>Invoice Total</label>
    <div><v-money :currency="model.CurrencyCode">{{ model.InvoiceTotalAmount }}</v-money></div>
  </div>
  
  <div class="column col-md-4">
    <label>Payments</label>
    <div><v-money :currency="model.CurrencyCode">{{ model.PaymentsAmount }}</v-money></div>
  </div>
  
  <div class="column col-md-4">
    <label>Balance</label>
    <div><v-money :currency="model.CurrencyCode">{{ model.Balance }}</v-money></div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    model: Object
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/font-awesome/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.column {
  @include theme {
  border-right: 1px solid v(background-light);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Payment/components/InvoiceDetails.vue